export enum SimulationStatus {
    running         = 1,
    downloading_datasets    = 2,
    downloading_netcdf    = 3,
    finished    = 10,
    error       = -100,
    aborted     = -101,
    failed      = -102
  }

export const getSimulationStatusTradKey = (status:SimulationStatus) => {
    switch(status){
        case SimulationStatus.downloading_datasets: return "SimulationStatus.DownloadingDatasets"
        case SimulationStatus.downloading_netcdf: return "SimulationStatus.DownloadingNetCdf"
        case SimulationStatus.finished: return "SimulationStatus.Finished"
        case SimulationStatus.error: return "SimulationStatus.Error"
        case SimulationStatus.aborted: return "SimulationStatus.Aborted"
        case SimulationStatus.failed: return "SimulationStatus.Failed"
        default: return "SimulationStatus.Running"
    }
}

export const getSimulationStatus = (status:string) => {
    switch(status) {
        //case "running": return SimulationStatus.running
        case "downloading_datasets": return SimulationStatus.downloading_datasets
        case "downloading_netcdf": return SimulationStatus.downloading_netcdf
        case "finished": return SimulationStatus.finished
        case "error": return SimulationStatus.error
        case "aborted": return SimulationStatus.aborted
        case "failed": return SimulationStatus.failed
        default: return SimulationStatus.running
    }
}